<template>
  <div
    class="information-showcase information-showcase--yellow-light"
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    :style="{
      'padding-top': paddingTop + 'px',
      'padding-bottom': paddingBottom + 'px',
      'background-color': useBackgroundColor
    }"
    @click="$emit('block:redirect')"
  >
    <div class="information-showcase__content">
      <h3>{{ mainFields.title?.value }}</h3>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="mainFields.text?.value" />
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>
